import { createAction } from '@reduxjs/toolkit';
import { IJob } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_JOBS } from '../../../../common';

export const setJobs = createAction<IJob[]>(
  `${MN_JOBS}/${TYPE_LIST}/${ACT_SET}`,
);
